// @flow
import React, { Component } from 'react';
import {
  ReferralOptionDiv,
  ReferralOptionCopyDiv,
  ReferralUrlA,
  ReferralOptionImg,
  ReferralOptionTitleDiv
} from './ReferralOptionsStyles';
import { DefaultIcon } from '../../../components/Icon';
import { copyToClipboard } from '../../../utilities/copyToClipboard';
import { PrimaryButton } from '../../../components/ButtonStyles';

type BaseProps = {
  title: string,
  icon?: string,
  iconSize?: string,
  text: string,
  image?: string,
  mainTitle: string
};
type CopyProps = {
  ...$Exact<BaseProps>,
  copyableUrl: string,
  linkText?: void,
  linkTo?: void
};

type LinkProps = {
  ...$Exact<BaseProps>,
  copyableUrl: string,
  linkText: string,
  linkTo: string
};

type Props = CopyProps | LinkProps;

export default class ReferralOption extends Component<Props> {
  handleCopy = () => {
    copyToClipboard(this.props.copyableUrl);
  };

  render() {
    const { copyableUrl, linkText } = this.props;
    return (
      <ReferralOptionDiv>
        <ReferralOptionTitleDiv>
          {this.props.icon && (
            <DefaultIcon
              iconSize={this.props.iconSize}
              name={this.props.icon}
            />
          )}
          {this.props.image && <ReferralOptionImg src={this.props.image} />}
          <h4>
            <span>{this.props.mainTitle} </span>
            {this.props.title}
          </h4>
        </ReferralOptionTitleDiv>
        <p>{this.props.text}</p>

        <ReferralOptionCopyDiv>
          <ReferralUrlA href={copyableUrl}>{copyableUrl}</ReferralUrlA>
          <PrimaryButton onClick={this.handleCopy}>{linkText}</PrimaryButton>
        </ReferralOptionCopyDiv>
      </ReferralOptionDiv>
    );
  }
}
